var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "admin-page" }, [
    _c("div", { staticClass: "main-cnt" }, [
      _c("div", { staticClass: "content-white" }, [
        _c("div", { staticClass: "content-header ex-input-heading" }, [
          _c(
            "form",
            {
              staticClass: "form-group",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.searchOCR.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-3" }, [
                  _c("div", { staticClass: "form-input ex-w-50" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-input-lb",
                        attrs: { for: "branchId" }
                      },
                      [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.$t("branch.general.name")) +
                            "\n                                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-input-cnt" },
                      [
                        _c("select2", {
                          attrs: {
                            id: "branchId",
                            name: "branchId",
                            options: _vm.branchSelectOptions,
                            settings: _vm.branchSelectSettings
                          },
                          on: {
                            change: function($event) {
                              return _vm.branchSelectChangeEvent($event)
                            },
                            select: function($event) {
                              return _vm.branchSelectEvent($event)
                            }
                          },
                          model: {
                            value: _vm.search.branchId,
                            callback: function($$v) {
                              _vm.$set(_vm.search, "branchId", $$v)
                            },
                            expression: "search.branchId"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c("div", { staticClass: "form-input ex-w-34" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-input-lb",
                        attrs: { for: "departmentId" }
                      },
                      [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.$t("department.general.name")) +
                            "\n                                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-input-cnt" },
                      [
                        _c("select2", {
                          attrs: {
                            id: "departmentId",
                            name: "departmentId",
                            options: _vm.departmentSelectOptions,
                            settings: _vm.departmentSelectSettings
                          },
                          on: {
                            change: function($event) {
                              return _vm.departmentSelectChangeEvent($event)
                            },
                            select: function($event) {
                              return _vm.departmentSelectEvent($event)
                            }
                          },
                          model: {
                            value: _vm.search.departmentId,
                            callback: function($$v) {
                              _vm.$set(_vm.search, "departmentId", $$v)
                            },
                            expression: "search.departmentId"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-input ex-w-84",
                      attrs: { for: "groupId" }
                    },
                    [
                      _c("label", { staticClass: "form-input-lb" }, [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.$t("group.general.short_name")) +
                            "\n                                "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-input-cnt" },
                        [
                          _c("select2", {
                            attrs: {
                              id: "groupId",
                              name: "groupId",
                              options: _vm.groupSelectOptions,
                              settings: _vm.groupSelectSettings
                            },
                            on: {
                              change: function($event) {
                                return _vm.groupSelectChangeEvent($event)
                              },
                              select: function($event) {
                                return _vm.groupSelectEvent($event)
                              }
                            },
                            model: {
                              value: _vm.search.groupId,
                              callback: function($$v) {
                                _vm.$set(_vm.search, "groupId", $$v)
                              },
                              expression: "search.groupId"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-search-cir",
                      attrs: { type: "submit", disabled: _vm.submitted }
                    },
                    [_c("i", { staticClass: "icon-search-w" })]
                  )
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-body" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("div", { staticClass: "row h-100" }, [
              _c("div", { staticClass: "col-12 h-100" }, [
                _c("div", { staticClass: "block-cnt" }, [
                  _vm.loading == true
                    ? _c("div", {
                        staticClass: "loading",
                        attrs: { "data-vv-scope": "s1" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.listsGroup != null && _vm.loading == false
                    ? _c(
                        "div",
                        {
                          staticClass: "table-list",
                          attrs: { "data-vv-scope": "s2" }
                        },
                        [
                          _c(
                            "table",
                            { staticClass: "table" },
                            [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("branch.general.full_name"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("department.general.name"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("group.general.full_name"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("login.user_name")))
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("ocr.general.date")))
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("ocr.general.page")))
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("ocr.general.char_count"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.listsGroup, function(item) {
                                return _c("tr", { key: item.id }, [
                                  _c("td", [_vm._v(_vm._s(item.branch_name))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.department_name))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.group_name))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.user_full_name))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.month))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.page))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.char_count))])
                                ])
                              })
                            ],
                            2
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _vm.lastPage > 1
                    ? _c(
                        "div",
                        {
                          staticClass: "page-block",
                          attrs: { "data-vv-scope": "s3" }
                        },
                        [
                          _c("paginate", {
                            class: "",
                            attrs: {
                              "page-count": _vm.lastPage,
                              "page-range": 3,
                              "margin-pages": 1,
                              "click-handler": _vm.requestPagination,
                              "prev-text": _vm.$t("pagination.prev"),
                              "next-text": _vm.$t("pagination.next"),
                              "container-class": "pagination",
                              "page-class": "page-item",
                              "prev-class": "page-item",
                              "next-class": "page-item",
                              "page-link-class": "page-link",
                              "prev-link-class": "page-link",
                              "next-link-class": "page-link"
                            },
                            model: {
                              value: _vm.page,
                              callback: function($$v) {
                                _vm.page = $$v
                              },
                              expression: "page"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _vm.listsGroup == null && _vm.loading == false
                    ? _c(
                        "div",
                        {
                          staticClass: "no-data",
                          attrs: { "data-vv-scope": "s4" }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("general.no_data")) +
                              "\n                                "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bfcb5dca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfcb5dca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/admin/OCRManagement/List.vue
// module id = null
// module chunks = 